define('pages/ad_form/copy_ad_modal_view',[
  'backbone',
  'jquery',
  '_',
  'text!./copy_ad_modal_template.html'
], function (Backbone, $, _,
             modal_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.render();
    },

    tagName: 'div',
    className: 'copy-ad-modal',
    template: _.template(modal_template),

    events: {
      'click .js-confirm-button': 'copyAd'
    },

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    copyAd: function (e) {
      e.preventDefault();
      this.trigger('copyAd');
      this.trigger('close');
    },

    remove: function () {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });
  return View;
});

